export default __webpack_public_path__ + "static/agreement-5b3663784704b8681836f6bc5b34a8d1.svg";